/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RewardLog } from '../../models/reward-log';

export interface RewardLogsControllerFindOne$Params {
  id: string;
}

export function rewardLogsControllerFindOne(http: HttpClient, rootUrl: string, params: RewardLogsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<RewardLog>> {
  const rb = new RequestBuilder(rootUrl, rewardLogsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RewardLog>;
    })
  );
}

rewardLogsControllerFindOne.PATH = '/reward-logs/{id}';
